import { useState } from "react";
import type { AuditEvent } from "../domain";
import { useLocale } from "../i18n";

export function AuditList({ items, date }: { items: AuditEvent[]; date: (value: string) => string }) {
  const { w } = useLocale();
  const [visible, setVisible] = useState(20);
  return <>
    <div className="audit-list">{items.slice(0,visible).map(item => <article key={item.id}>
      <span className="audit-dot" aria-hidden="true"/>
      <div><strong>{item.action === "otp.counter.reset" ? w("إعادة ضبط عداد رموز التحقق", "Verification-code counter reset") : item.action}</strong><p>{item.actor}</p>
        <details className="audit-record-details"><summary>{w("تفاصيل الإجراء", "Action details")}</summary>
          <dl><div><dt>{w("العنصر", "Record")}</dt><dd><bdi>{item.target}</bdi></dd></div>
            {item.reason && <div><dt>{w("السبب", "Reason")}</dt><dd>{item.reason}</dd></div>}
            {item.beforeState && <div><dt>{w("قبل التغيير", "Before")}</dt><dd><bdi>{item.beforeState}</bdi></dd></div>}
            {item.afterState && <div><dt>{w("بعد التغيير", "After")}</dt><dd><bdi>{item.afterState}</bdi></dd></div>}
          </dl>
        </details>
      </div><time dateTime={item.at}>{date(item.at)}</time>
    </article>)}</div>
    {!!items.length && <div className="audit-pagination"><span>{w("المعروض من السجل المحمّل", "Shown from the loaded records")}: {Math.min(visible,items.length)} / {items.length}</span>
      {visible<items.length && <button type="button" className="secondary" onClick={()=>setVisible(n=>n+20)}>{w("إظهار المزيد من الإجراءات", "Show more actions")}</button>}
    </div>}
  </>;
}
